export default __webpack_public_path__ + "static/media/add.89566f27.svg";